import { Injectable } from '@angular/core';
import { ServiceLibrary } from '@common_libraries/helpers/ServiceLibrary';
import { Observable } from 'rxjs';
import { Dictionary } from '@common_libraries/helpers/Dictionary';
import { map } from 'rxjs/operators';
import { NotificationItem } from '@serviceModels/NotificationCenter.models';

@Injectable({providedIn: 'root'})
export class NotificationCenterService {
  constructor(private servLib: ServiceLibrary) {}

  GetNotifications(): Observable<NotificationItem[]> {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet(
      '/v1/api/NotificationCenter/GetForUser',
      ServiceLibrary.ContentType.JSON,
      parameters
    ).pipe(map((res: any) => res.json.data));
  }

  GetUnShownNotifications(): Observable<NotificationItem[]> {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet(
      '/v1/api/NotificationCenter/GetForUserUnShown',
      ServiceLibrary.ContentType.JSON,
      parameters
    ).pipe(map((res: any) => res.json.data));
  }

  GetNotificationUnReadCount(): Observable<number> {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet(
      '/v1/api/NotificationCenter/UserUnreadCount',
      ServiceLibrary.ContentType.JSON,
      parameters
    ).pipe(map((res: any) => res.json.data));
  }

  GetLastModifiedDate(): Observable<number> {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGetPolling(
      '/v1/api/NotificationCenter/LastModifiedDate',
      ServiceLibrary.ContentType.JSON,
      parameters
    ).pipe(map((res: any) => res.json.data));
  }

  MarkAsRead(notifyID: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet(
      '/v1/api/NotificationCenter/' + notifyID + '/MarkAsRead',
      ServiceLibrary.ContentType.JSON,
      parameters
    );
  }

  Delete(notifyID: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet(
      '/v1/api/NotificationCenter/' + notifyID + '/Delete',
      ServiceLibrary.ContentType.JSON,
      parameters
    );
  }

  MarkAllAsRead(notifyTypeID: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet(
      '/v1/api/NotificationCenter/' + notifyTypeID + '/MarkAllAsRead',
      ServiceLibrary.ContentType.JSON,
      parameters
    );
  }

  DeleteAll(notifyTypeID: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet(
      '/v1/api/NotificationCenter/' + notifyTypeID + '/DeleteAll',
      ServiceLibrary.ContentType.JSON,
      parameters
    );
  }

}
